import * as React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"

const MurahPage = () => (
  <Layout>
  <div className="masthead-followup row m-0 bg-white border border-white text-center">
	  <div className="col-12 col-md-12 p-12 p-3 p-md-5 bg-white border border-white text-center">
    <Seo title="MESIN KASIR MURAH KEREN MODERN TERBARU NEW TAHUN INI" />
    <h2><strong>HYBRID TABLET POS</strong></h2>
    <p>
Era mesin kasir terbaru modern dengan touchscreen metode tersemat pada mesin kasir murah untuk menunjang usaha dan bisnismu, murah nan elegan dan mewah diproduksi hewllet packard technology memberikan yang terbaik untuk digunakan menunjang usaha kecil mu, dapat juga digunakan untuk menjadi waiters order dalam usaha restoran cafe maupun untuk tablet office guna cek pembukuan dan laporan detail untuk admin,menjadikan nya fleksibel dalam setiap pekerjaan.
	</p>
  <div className="embed-responsive embed-responsive-16by9">
<iframe title="mesin kasir portable murah" width="560" height="315" src="https://www.youtube.com/embed/cRKPNLRBTFU" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>
    <p>
Sensitif touchscreen layar sentuh nya semakin memepercepat untuk digunakan transaksi kasir point of sale, selain itu tablet windows menjadi kan nya sempurna untuk digunakan menunjang pekerjaan dan tentunya tahan lama dalam aktivitas ,bonus dock keyboard semakin nyaman untuk digunakan menjadi laptop guna kebutuhan penegetikan ini lah solusi mesin kasir portable murah dan terbaik untuk digunakan, berbagai dukungan aplikasi software tersedia sesuai kebutuhan mu.
</p>
<a href="https://mesinkasir.github.io/e-catalog/Mesin%20kasir%20tablet%20pos%20hybrid.pdf" target="blank" className="button" title="donwload hybrid tab">Download</a>
<p>Download e-Catalog untuk cek harga dan pilihan paket.</p>
<p>Sangat cocok digunakan pada usaha kecil seperti shop store toko modern mart hingga restoran cafe rumah makan hingga kuliner lain seperti warkop angkringan banyak menggunakan mesin kasir portable murah ini.
</p>
<Link to="/touchscreenpos" className="button button-outline float-left" title="touchscreenpos">&larr; Touchscreen POS</Link> <Link to="/security" className="button button-outline float-right" title="alarm security">Alarm &rarr;</Link>
</div>

	</div>
  </Layout>
)

export default MurahPage